import _JSON$stringify from 'babel-runtime/core-js/json/stringify';
import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import RestService from './RestService';
import yamljs from 'yamljs';
import logger from 'js-logger';

/** Methods to interact with the REST, import, and vehicle services */

var FormConfigService = function () {
  function FormConfigService() {
    _classCallCheck(this, FormConfigService);
  }

  _createClass(FormConfigService, null, [{
    key: 'init',
    value: function init() {
      this.rest = new RestService();
    }
  }, {
    key: 'getAllFormConfigs',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var response, productLines, index;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return this.rest.getAllProductLines();

              case 3:
                response = _context.sent;
                productLines = response.data;
                index = 0;

              case 6:
                if (!(index < productLines.length)) {
                  _context.next = 12;
                  break;
                }

                _context.next = 9;
                return this.loadFormConfigByType(productLines[index].name);

              case 9:
                index++;
                _context.next = 6;
                break;

              case 12:
                _context.next = 14;
                return this.loadFormConfigByType('CUSTOMER');

              case 14:
                _context.next = 19;
                break;

              case 16:
                _context.prev = 16;
                _context.t0 = _context['catch'](0);

                if (typeof _context.t0.response !== 'undefined') {
                  logger.error(_context.t0.response.data);
                  this.serverError = true;
                } else {
                  logger.error(_context.t0);
                  this.serverError = true;
                }

              case 19:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 16]]);
      }));

      function getAllFormConfigs() {
        return _ref.apply(this, arguments);
      }

      return getAllFormConfigs;
    }()
  }, {
    key: 'loadFormConfigByType',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(type) {
        var response, responseForDefaultConfig;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                if (!(type === 'CUSTOMER')) {
                  _context2.next = 7;
                  break;
                }

                _context2.next = 4;
                return this.rest.getCustomerConfigForm();

              case 4:
                _context2.t0 = _context2.sent;
                _context2.next = 10;
                break;

              case 7:
                _context2.next = 9;
                return this.rest.getConfigForm(type);

              case 9:
                _context2.t0 = _context2.sent;

              case 10:
                response = _context2.t0;

                if (!(response.status === 204)) {
                  _context2.next = 31;
                  break;
                }

                _context2.prev = 12;

                if (!(type === 'CUSTOMER')) {
                  _context2.next = 19;
                  break;
                }

                _context2.next = 16;
                return this.rest.getDefaultCustomerConfigForm();

              case 16:
                _context2.t1 = _context2.sent;
                _context2.next = 22;
                break;

              case 19:
                _context2.next = 21;
                return this.rest.getDefaultConfigForm(type);

              case 21:
                _context2.t1 = _context2.sent;

              case 22:
                responseForDefaultConfig = _context2.t1;

                if (responseForDefaultConfig.status === 204) {
                  this.missingConfigs.push(type);
                } else {
                  this.formConfigs[type] = type === 'CUSTOMER' || type.endsWith(this.typeNewPolicySuffix) || type.endsWith(this.typeEditPolicySuffix) ? _JSON$stringify(responseForDefaultConfig.data, null, '\t') : responseForDefaultConfig.data;
                }
                _context2.next = 29;
                break;

              case 26:
                _context2.prev = 26;
                _context2.t2 = _context2['catch'](12);

                if (typeof _context2.t2.response !== 'undefined') {
                  logger.error(_context2.t2.response.data);
                  this.serverError = true;
                } else {
                  logger.error(_context2.t2);
                  this.serverError = true;
                }

              case 29:
                _context2.next = 32;
                break;

              case 31:
                this.formConfigs[type] = type === 'CUSTOMER' || type.endsWith(this.typeNewPolicySuffix) || type.endsWith(this.typeEditPolicySuffix) ? _JSON$stringify(response.data, null, '\t') : response.data;

              case 32:
                _context2.next = 37;
                break;

              case 34:
                _context2.prev = 34;
                _context2.t3 = _context2['catch'](0);

                if (typeof _context2.t3.response !== 'undefined') {
                  logger.error(_context2.t3.response.data);
                  this.serverError = true;
                } else {
                  logger.error(_context2.t3);
                  this.serverError = true;
                }

              case 37:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 34], [12, 26]]);
      }));

      function loadFormConfigByType(_x) {
        return _ref2.apply(this, arguments);
      }

      return loadFormConfigByType;
    }()
  }, {
    key: 'ensureFormConfigIsLoaded',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(type) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (this.formConfigs[type]) {
                  _context3.next = 3;
                  break;
                }

                _context3.next = 3;
                return this.loadFormConfigByType(type);

              case 3:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function ensureFormConfigIsLoaded(_x2) {
        return _ref3.apply(this, arguments);
      }

      return ensureFormConfigIsLoaded;
    }()
  }, {
    key: 'parseFormConfig',
    value: function parseFormConfig(type) {
      if (!this.formConfigs[type]) {
        logger.error('Not able to parse config for type: ' + type);
      } else {
        return type === 'CUSTOMER' || type.endsWith(this.typeNewPolicySuffix) || type.endsWith(this.typeEditPolicySuffix) ? JSON.parse(this.formConfigs[type]) : yamljs.parse(this.formConfigs[type]);
      }
    }
  }, {
    key: 'ensureFormConfigIsLoadedAndParse',
    value: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(type) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.ensureFormConfigIsLoaded(type);

              case 2:
                return _context4.abrupt('return', this.parseFormConfig(type));

              case 3:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function ensureFormConfigIsLoadedAndParse(_x3) {
        return _ref4.apply(this, arguments);
      }

      return ensureFormConfigIsLoadedAndParse;
    }()
  }, {
    key: 'updateFormConfig',
    value: function updateFormConfig(type, config) {
      if (type != null && config != null) {
        this.formConfigs[type] = config;
      }
    }
  }, {
    key: 'getFormConfig',
    value: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(type) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.loadFormConfigByType(type);

              case 2:
                return _context5.abrupt('return', this.formConfigs[type]);

              case 3:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function getFormConfig(_x4) {
        return _ref5.apply(this, arguments);
      }

      return getFormConfig;
    }()
  }, {
    key: 'getMissingConfigs',
    value: function getMissingConfigs() {
      return this.missingConfigs;
    }
  }, {
    key: 'getServerError',
    value: function getServerError() {
      return this.serverError;
    }
  }]);

  return FormConfigService;
}();

FormConfigService.formConfigs = {};
FormConfigService.missingConfigs = [];
FormConfigService.serverError = false;
FormConfigService.typeNewPolicySuffix = '_NEW';
FormConfigService.typeEditPolicySuffix = '_JSON';
export default FormConfigService;


// WEBPACK FOOTER //
// ./src/service/FormConfigService.js